import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import { connect, useDispatch } from 'react-redux';
import {
    ButtonGroup,
    Button,
    SelectControl,
    SegmentLoader,
    Row,
    Col,
    InputControl,
} from '@si-armes/dsfr-react';
import { useForm, FormProvider } from 'react-hook-form';
import moment from 'moment';
import InputFiles from 'components/Commun/Form/InputFiles';
import FileUploadeAbstract from 'components/Commun/Form/InputFiles/Model/FileUploadeAbstract';
import { getDateFormatWithSlash } from 'components/Commun/Form/maskFunctions';
import SelectPays from 'components/form/referentiel/select/SelectPays';
import SelectCommune from 'components/form/referentiel/select/SelectCommune';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_COMPTE_CREER_IDENTITE_URL,
    API_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
    API_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2_URL,
    API_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
    API_ENREGISTRER_VERSO_LICENCE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
    API_ENREGISTRER_AUTORISATION_DETENTION_ARME_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
    API_ENREGISTRER_PIECE_JUSTIFICATIVE_MINEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
    API_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
    CONTEXT_CREER_COMPTE_ETAPE_IDENTITE,
    CONTEXT_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2,
    CONTEXT_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_VERSO_LICENCE_TIR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_VERSO_LICENCE_BALLTRAP_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_VERSO_LICENCE_SKI_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_AUTORISATION_DETENTION_ARME_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_PIECE_JUSTIFICATIVE_MINEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
    CONTEXT_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
} from 'constants/apiUrls.constants';
import {
    REGEXP_DATE_AVEC_MOIS_JOUR_INCONNU,
    REGEXP_DATE_AVEC_ANNEE,
    REGEXP_NOM_PRENOM,
    AGE_MAJORITE,
    AGE_MINIMUM_CHASSEUR,
    AGE_MINIMUM_LICENCIE,
} from 'constants/contraintes.constants';
import {
    CLEAR_ALERTES,
    formaterOptions,
    getMessageErreurChampManquant,
    getPatternHookFormValidation,
} from 'utils/utils';
import { MESSAGE_DATE_INVALIDE } from 'constants/messagePersonalise.constants';
import useToaster from 'hooks/useToaster';
import {
    FEATURE_APPEL_API_FFBT,
    FEATURE_APPEL_API_FFTIR,
    isFeatureActive,
} from 'components/FeatureFlipping/featureFlipping.func';
import formaterCreationIdentite from './FormaterCreationIdentite';
import InformationChasseur from './licence/InformationChasseur';
import InformationLicencie from './licence/InformationLicencie';
import InformationLicencieMineur from './licence/InformationLicencieMineur';
import InformationPersonneRisque from './licence/InformationPersonneRisque';
import formaterFichiersPiecesIdentiteEtape1 from './FormaterFichiersPiecesIdentiteEtape1';
import formaterFichierPermisDeChasse from './FormaterFichierPermisDeChasse';
import formaterFichierValidationPermisChasser from './FormaterFichierValidationPermisChasser';
import formaterFichierVersoLicenceSki from './FormaterFichierVersoLicenceSki';
import formaterFichierVersoLicenceBallTrap from './FormaterFichierVersoLicenceBallTrap';
import formaterFichierVersoLicenceTir from './FormaterFichierVersoLicenceTir';
import formaterFichierPieceJustificativeMineur from './FormaterFichierPieceJustificativeMineur';
import formaterFichierCarteCollectionneur from './FormaterFichierCarteCollectionneur';
import ChampsCarteCollectionneur from './ChampsCarteCollectionneur';
import InfoChampsObligatoire from '../../../../../../components/form/infoObligatoire/InfoChampsObligatoire';
import { hideAllNotification } from '../../../../../../store/alertes/alertesReducer';
import formaterFichierAutorisationDetentionArme from './FormaterFichierAutorisationDetentionArme';
import { NUMERO_FRANCE } from '../../../../../../constants/select.constants';

// @todo Refacto le composant (Utiliser le validator de ReactHookForm, éviter les setValue, trigger
const CreerCompteIdentite = ({
    dataIdentiteRenseignee,
    setEtapeIdentite,
    setAncienLicencie,
    postApi,
    isLoading,
    retourEtape,
    erreur,
    message,
    data,
    uuidBrouillon,
    motifs,
    reinitialiseApi,
    isLoadingRenseignerPiecesIdentite,
    erreurRenseignerPiecesIdentite,
    dataRenseignerPiecesIdentite,
    isLoadingPermisDeChasse,
    erreurPermisDeChasse,
    dataRenseignerPermisDeChasse,
    isLoadingAutorisationPortArme,
    erreurAutorisationPortArme,
    dataRenseignerAutorisationPortArme,
    isLoadingValidationPermisChasser,
    erreurValidationPermisChasser,
    dataRenseignerValidationPermisChasser,
    isLoadingVersoLicenceSki,
    erreurVersoLicenceSki,
    dataRenseignerVersoLicenceSki,
    isLoadingVersoLicenceBallTrap,
    erreurVersoLicenceBallTrap,
    dataRenseignerVersoLicenceBallTrap,
    isLoadingVersoLicenceTir,
    erreurVersoLicenceTir,
    dataRenseignerVersoLicenceTir,
    isLoadingPieceJustificativeMineur,
    erreurPieceJustificativeMineur,
    dataRenseignerPieceJustificativeMineur,
    isLoadingCarteCollectionneur,
    erreurCarteCollectionneur,
    dataRenseignerCarteCollectionneur,
    featureFlipping,
    clearAlertes,
    statutCompteMetierAsso,
}) => {
    const IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE =
        statutCompteMetierAsso?.statut === 'detenteur-metier-physique';

    const IS_METIER_ET_ASSOCIATION_PERSONNE_MORAL =
        statutCompteMetierAsso?.statut === 'detenteur-metier-morale';

    const IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_LOUVETERIE =
        IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE &&
        statutCompteMetierAsso?.typeMetierAssociation === 'metier.physique.louveterie';

    const IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_RISQUE_PRO =
        IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE &&
        statutCompteMetierAsso?.typeMetierAssociation === 'metier.physique.risques_pro';

    const IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_RISQUE_EXCEPTIONNELS =
        IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE &&
        statutCompteMetierAsso?.typeMetierAssociation === 'metier.physique.risques_exceptionnels';

    const IS_COLLECTIONNEUR_PHYSIQUE =
        statutCompteMetierAsso?.statut === 'detenteur-collectionneur-physique';

    const IS_CHASSEUR_STATUT =
        (motifs && motifs.isChasseur) ||
        (motifs.isDetenteurProfessionnel && IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_LOUVETERIE);

    const hookForm = useForm({
        mode: 'onChange',
        defaultValues: {
            paysNaissance: '75',
            ...dataIdentiteRenseignee,
        },
    });

    const dispatch = useDispatch();
    const { register, handleSubmit, getValues, watch, formState, trigger, setValue } = hookForm;
    const [dataIdentite, setDataIdentite] = useState();

    // SelectCommune params
    const [valueRecherche, setValueRecherche] = useState(getValues('lieuNaissance') ?? '');

    const choixSexe = [
        { key: 'F', value: '2', libelle: 'Féminin' },
        { key: 'M', value: '1', libelle: 'Masculin' },
    ];

    const typePieceIdentite = [
        { key: 'CNI', value: 2, libelle: "Carte nationale d'identité" },
        { key: 'passeport', value: 33, libelle: 'Passeport' },
        { key: 'titreSejour', value: 34, libelle: 'Titre de séjour' },
        { key: 'pieceIdentiteEtrangere', value: 35, libelle: 'Pièce identité étrangère' },
    ];

    const { triggerToaster, closeToaster } = useToaster();

    useEffect(() => {
        if (dataIdentiteRenseignee) {
            setValue('piecesIdentite', dataIdentiteRenseignee.piecesIdentite);
            setValue(
                'justificatifMetierEtAssociation',
                dataIdentiteRenseignee.justificatifMetierEtAssociation,
            );
            setValue('versoLicenceSki', dataIdentiteRenseignee.versoLicenceSki);
            setValue('versoLicenceBallTrap', dataIdentiteRenseignee.versoLicenceBallTrap);
            setValue('numeroGuichetUnique', dataIdentiteRenseignee.numeroGuichetUnique);
            setValue('permisDeChasse', dataIdentiteRenseignee.permisDeChasse);
            setValue('validationPermisChasser', dataIdentiteRenseignee.validationPermisChasser);
            setValue(
                'selectLicencieOrAncienLicencieTir',
                dataIdentiteRenseignee.selectLicencieOrAncienLicencieTir,
            );
            setValue(
                'selectLicencieOrAncienLicencieSki',
                dataIdentiteRenseignee.selectLicencieOrAncienLicencieSki,
            );
            setValue(
                'selectLicencieOrAncienLicencieBallTrap',
                dataIdentiteRenseignee.selectLicencieOrAncienLicencieBallTrap,
            );
            setValue('typeLicenceMineur', dataIdentiteRenseignee.typeLicenceMineur);
            setValue('carteCollectionneur', dataIdentiteRenseignee.carteCollectionneur);
            setValue(
                'dateDelivranceCarteCollectionneur',
                dataIdentiteRenseignee.dateDelivranceCarteCollectionneur,
            );
        }
    }, []);

    async function postPiecesIdentite() {
        (await formaterFichiersPiecesIdentiteEtape1(dataIdentite)).forEach((value, index) => {
            postApi(
                usagerClientReducer,
                API_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2_URL.replace(
                    '{index}',
                    index + 1,
                ),
                {
                    pieceIdentite: value,
                    key: index + 1,
                    uuidBrouillon,
                },
                CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2,
            );
        });
    }

    async function postAutorisisationDetentionArme() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_AUTORISATION_DETENTION_ARME_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                autorisationDetentionArme: await formaterFichierAutorisationDetentionArme(
                    dataIdentite,
                ),
                uuidBrouillon,
            },
            CONTEXT_ENREGISTRER_AUTORISATION_DETENTION_ARME_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    async function postPermisDeChasse() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                permisDeChasse: await formaterFichierPermisDeChasse(dataIdentite),
                uuidBrouillon,
            },
            CONTEXT_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }
    async function postValidationPermisChasser() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                validationPermisChasser: await formaterFichierValidationPermisChasser(dataIdentite),
                uuidBrouillon,
            },
            CONTEXT_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    async function postVersoLicenceSki() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_VERSO_LICENCE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                versoLicence: await formaterFichierVersoLicenceSki(dataIdentite),
                uuidBrouillon,
                typeLicence: 'licenceDeSki',
            },
            CONTEXT_ENREGISTRER_VERSO_LICENCE_SKI_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    async function postVersoLicenceBallTrap() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_VERSO_LICENCE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                versoLicence: await formaterFichierVersoLicenceBallTrap(dataIdentite),
                uuidBrouillon,
                typeLicence: 'licenceBallTrap',
            },
            CONTEXT_ENREGISTRER_VERSO_LICENCE_BALLTRAP_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    async function postVersoLicenceTir() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_VERSO_LICENCE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                versoLicence: await formaterFichierVersoLicenceTir(dataIdentite),
                uuidBrouillon,
                typeLicence: 'licenceDeTir',
            },
            CONTEXT_ENREGISTRER_VERSO_LICENCE_TIR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    async function postPieceJustificativeMineur() {
        const type =
            dataIdentite.nationalite === NUMERO_FRANCE
                ? 'ACTE_NAISSANCE'
                : 'CERTIFICAT_NON_INSCRIPTION';

        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_PIECE_JUSTIFICATIVE_MINEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                pieceJustificativeMineur: await formaterFichierPieceJustificativeMineur(
                    dataIdentite,
                ),
                uuidBrouillon,
                type,
            },
            CONTEXT_ENREGISTRER_PIECE_JUSTIFICATIVE_MINEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    async function postCarteCollectionneur() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                carteCollectionneur: await formaterFichierCarteCollectionneur(dataIdentite),
                numero: dataIdentite.numeroCarteCollectionneur,
                dateDelivrance: dataIdentite.dateDelivranceCarteCollectionneur,
                uuidBrouillon,
            },
            CONTEXT_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    function conditionPourPasserEtapeSuivante() {
        const informationsIdentiteEnvoyee = isLoading === false && data && !erreur;

        const piecesIdentiteEnvoyee =
            !isLoadingRenseignerPiecesIdentite &&
            dataRenseignerPiecesIdentite &&
            !erreurRenseignerPiecesIdentite;

        const permisDeChasseEnvoyee =
            !isLoadingPermisDeChasse && dataRenseignerPermisDeChasse && !erreurPermisDeChasse;

        const autorisationPortArmeEnvoyee =
            !isLoadingAutorisationPortArme &&
            dataRenseignerAutorisationPortArme &&
            !erreurAutorisationPortArme;

        const IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_PERSONNE_RISQUE_STATUT =
            motifs.isDetenteurProfessionnel &&
            (IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_RISQUE_EXCEPTIONNELS ||
                IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_RISQUE_PRO);

        const IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_LOUVETERIE_STATUT =
            motifs.isDetenteurProfessionnel &&
            IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_LOUVETERIE;

        if (IS_COLLECTIONNEUR_PHYSIQUE) {
            const carteCollectionneurEnvoyee =
                !isLoadingCarteCollectionneur &&
                dataRenseignerCarteCollectionneur &&
                !erreurCarteCollectionneur;

            return (
                informationsIdentiteEnvoyee && piecesIdentiteEnvoyee && carteCollectionneurEnvoyee
            );
        }

        if (IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_PERSONNE_RISQUE_STATUT)
            return (
                informationsIdentiteEnvoyee && piecesIdentiteEnvoyee && autorisationPortArmeEnvoyee
            );

        if (IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_LOUVETERIE_STATUT)
            return informationsIdentiteEnvoyee && piecesIdentiteEnvoyee && permisDeChasseEnvoyee;

        const validationPermisChasserEnvoyee =
            !isLoadingValidationPermisChasser &&
            dataRenseignerValidationPermisChasser &&
            !erreurValidationPermisChasser;

        const versoLicenceSkiEnvoyee =
            isLoadingVersoLicenceSki === false &&
            dataRenseignerVersoLicenceSki &&
            !erreurVersoLicenceSki;
        const versoLicenceBallTrapEnvoyee =
            isLoadingVersoLicenceBallTrap === false &&
            dataRenseignerVersoLicenceBallTrap &&
            !erreurVersoLicenceBallTrap;
        const versoLicenceTirEnvoyee =
            isLoadingVersoLicenceTir === false &&
            dataRenseignerVersoLicenceTir &&
            !erreurVersoLicenceTir;

        const pieceJustificativeMineurEnvoyee =
            !isLoadingPieceJustificativeMineur &&
            dataRenseignerPieceJustificativeMineur &&
            !erreurPieceJustificativeMineur;

        if (motifs && motifs.isMineur) {
            const typeLicenceMineur = getValues('typeLicenceMineur');
            const permisChasseEnvoyee =
                !isLoadingPermisDeChasse && dataRenseignerPermisDeChasse && !erreurPermisDeChasse;
            const versoLicenceTirNecessaire =
                typeLicenceMineur === 'tir' &&
                getValues('selectLicencieOrAncienLicencieTir') === 'isLicencie';
            const versoLicenceBallTrapNecessaire =
                typeLicenceMineur === 'ballTrap' &&
                getValues('selectLicencieOrAncienLicencieBallTrap') === 'isLicencie';
            const versoLicenceSkiNecessaire =
                typeLicenceMineur === 'ski' &&
                getValues('selectLicencieOrAncienLicencieSki') === 'isLicencie';
            const versoLicenceMineurEnvoyee =
                (typeLicenceMineur === 'tir' &&
                    (!versoLicenceTirNecessaire || versoLicenceTirEnvoyee)) ||
                (typeLicenceMineur === 'ballTrap' &&
                    (!versoLicenceBallTrapNecessaire || versoLicenceBallTrapEnvoyee)) ||
                (typeLicenceMineur === 'ski' &&
                    (!versoLicenceSkiNecessaire || versoLicenceSkiEnvoyee));

            const licenceEnvoyee =
                (typeLicenceMineur === 'permisChasse' && permisChasseEnvoyee) ||
                versoLicenceMineurEnvoyee;

            return (
                piecesIdentiteEnvoyee &&
                informationsIdentiteEnvoyee &&
                pieceJustificativeMineurEnvoyee &&
                licenceEnvoyee
            );
        }

        return (
            piecesIdentiteEnvoyee &&
            informationsIdentiteEnvoyee &&
            ((motifs && motifs.isChasseur && permisDeChasseEnvoyee) ||
                validationPermisChasserEnvoyee ||
                (motifs &&
                    motifs.isLicencie &&
                    ((dataIdentite && dataIdentite.numeroLicenceTir) ||
                        versoLicenceSkiEnvoyee ||
                        versoLicenceBallTrapEnvoyee ||
                        versoLicenceTirEnvoyee ||
                        ((watch('selectLicencieOrAncienLicencieTir') === 'isAncienLicencie' ||
                            !watch('selectLicencieOrAncienLicencieTir')) &&
                            (watch('selectLicencieOrAncienLicencieBallTrap') ===
                                'isAncienLicencie' ||
                                !watch('selectLicencieOrAncienLicencieBallTrap')) &&
                            (watch('selectLicencieOrAncienLicencieSki') === 'isAncienLicencie' ||
                                !watch('selectLicencieOrAncienLicencieSki'))))) ||
                (motifs && motifs.isNonLicencie) ||
                (motifs && motifs.isDetenteurProfessionnel))
        );
    }

    useEffect(() => {
        if (conditionPourPasserEtapeSuivante()) {
            setEtapeIdentite(dataIdentite);

            const unAncienLicencie =
                motifs && motifs.isMineur
                    ? false
                    : getValues('selectLicencieOrAncienLicencieTir') === 'isAncienLicencie' ||
                      getValues('selectLicencieOrAncienLicencieBallTrap') === 'isAncienLicencie' ||
                      getValues('selectLicencieOrAncienLicencieSki') === 'isAncienLicencie';

            setAncienLicencie(unAncienLicencie);
        }
    }, [
        isLoading,
        data,
        erreur,
        isLoadingRenseignerPiecesIdentite,
        dataRenseignerPiecesIdentite,
        erreurRenseignerPiecesIdentite,
        isLoadingPermisDeChasse,
        dataRenseignerPermisDeChasse,
        erreurPermisDeChasse,
        isLoadingAutorisationPortArme,
        dataRenseignerAutorisationPortArme,
        erreurAutorisationPortArme,
        isLoadingValidationPermisChasser,
        dataRenseignerValidationPermisChasser,
        erreurValidationPermisChasser,
        isLoadingVersoLicenceSki,
        dataRenseignerVersoLicenceSki,
        erreurVersoLicenceSki,
        isLoadingVersoLicenceBallTrap,
        dataRenseignerVersoLicenceBallTrap,
        erreurVersoLicenceBallTrap,
        isLoadingVersoLicenceTir,
        dataRenseignerVersoLicenceTir,
        erreurVersoLicenceTir,
        isLoadingPieceJustificativeMineur,
        dataRenseignerPieceJustificativeMineur,
        erreurPieceJustificativeMineur,
        isLoadingCarteCollectionneur,
        dataRenseignerCarteCollectionneur,
        erreurCarteCollectionneur,
    ]);

    // on mount et unmount
    useEffect(() => {
        window.scrollTo(0, 0);
        reinitialiseApi(CONTEXT_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE);
        reinitialiseApi(
            CONTEXT_ENREGISTRER_AUTORISATION_DETENTION_ARME_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
        reinitialiseApi(CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2);
        reinitialiseApi(
            CONTEXT_ENREGISTRER_PIECE_JUSTIFICATIVE_MINEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
        reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_IDENTITE);
        reinitialiseApi(
            CONTEXT_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
        return () => {
            reinitialiseApi(
                CONTEXT_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
            );
            reinitialiseApi(
                CONTEXT_ENREGISTRER_AUTORISATION_DETENTION_ARME_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
            );
            reinitialiseApi(
                CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2,
            );
            reinitialiseApi(
                CONTEXT_ENREGISTRER_PIECE_JUSTIFICATIVE_MINEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
            );
            reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_IDENTITE);
            reinitialiseApi(
                CONTEXT_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
            );
        };
    }, []);

    // --------- GESTION DES ERREURS DE CHAMPS --------------

    // Revalider les champs prénoms quand un prénom est modifié.
    useEffect(() => {
        trigger(['prenomDeux', 'prenomTrois', 'prenomQuatre', 'prenomUsuel']);
    }, [
        watch('prenomUn'),
        watch('prenomDeux'),
        watch('prenomTrois'),
        watch('prenomQuatre'),
        watch('prenomUsuel'),
    ]);

    // Revalider le pays de Naissance
    useEffect(() => {
        trigger(['paysNaissance']);
    }, [watch('paysNaissance')]);

    const validatePrenomUsuel = (valuePrenomUsuel) => {
        if (
            valuePrenomUsuel &&
            valuePrenomUsuel !== getValues('prenomUn') &&
            valuePrenomUsuel !== getValues('prenomDeux') &&
            valuePrenomUsuel !== getValues('prenomTrois') &&
            valuePrenomUsuel !== getValues('prenomQuatre')
        ) {
            return 'Le prénom usuel doit correspondre à un des autres prénoms';
        }
        return null;
    };

    const validateDate = (dateValue) => {
        const dateSplit = dateValue.split('/');
        const dateExistante = new Date(dateSplit[2], dateSplit[1] - 1, dateSplit[0]);
        if (
            (dateSplit &&
                moment(`${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`).diff(moment()) > 0) ||
            (dateSplit[1] !== '00' &&
                dateSplit[0] !== '00' &&
                (dateExistante.getFullYear() !== parseInt(dateSplit[2], 10) ||
                    dateExistante.getMonth() + 1 !== parseInt(dateSplit[1], 10) ||
                    dateExistante.getDate() !== parseInt(dateSplit[0], 10)))
        ) {
            return MESSAGE_DATE_INVALIDE;
        }
        return null;
    };

    const validateAge = (valueDateNaissance) => {
        if (valueDateNaissance.length === 10) {
            const dateNaissanceSplit = valueDateNaissance.split('/');
            const today = new Date();
            const thisYear = today.getFullYear();
            const birthDay = dateNaissanceSplit[0];
            const birthMonth = dateNaissanceSplit[1];
            const birthYear = dateNaissanceSplit[2];
            const valideAge = new RegExp(REGEXP_DATE_AVEC_ANNEE);
            const typeLicence = getValues('typeLicenceMineur');

            if (valideAge.test(birthYear)) {
                const age = moment().diff(
                    moment(birthYear + birthMonth + birthDay, 'YYYYMMDD'),
                    'years',
                );

                const isAgeMineurPartiel =
                    (birthDay === '00' || birthMonth === '00') &&
                    birthYear > thisYear - AGE_MAJORITE;

                const isAgeMineur =
                    moment().diff(moment(birthYear + birthMonth + birthDay, 'YYYYMMDD'), 'years') <
                    AGE_MAJORITE;

                if (motifs && motifs.isMineur) {
                    if (age >= AGE_MAJORITE) {
                        return 'La date de naissance renseignée correspond à une personne majeure. Veuillez créer un compte détenteur majeur';
                    }

                    let ageMinimum = AGE_MAJORITE;

                    if (typeLicence === 'permisChasse') {
                        ageMinimum = AGE_MINIMUM_CHASSEUR;
                    } else if (
                        typeLicence === 'tir' ||
                        typeLicence === 'ballTrap' ||
                        typeLicence === 'ski'
                    ) {
                        ageMinimum = AGE_MINIMUM_LICENCIE;
                    }

                    if (age >= ageMinimum) {
                        return null;
                    }

                    if (ageMinimum === AGE_MINIMUM_CHASSEUR) {
                        return "L'âge minimum pour créer un compte chasseur est de 16 ans.";
                    }
                    return "L'âge minimum pour créer un compte licencié est de 12 ans.";
                }

                if (isAgeMineurPartiel || isAgeMineur) {
                    return 'La date de naissance renseignée correspond à une personne mineure. Veuillez créer un compte détenteur mineur.';
                }
            }
        }

        return null;
    };

    // --------- GESTION DE LA VALIDATION ET ENVOI DU FORMULAIRE --------------
    // A REFACTO => Utiliser react hook form
    const hasFormValid = () => {
        let formulaireEstValide = formState.isValid;

        // verification de la pièce d'identité;
        formulaireEstValide =
            formulaireEstValide &&
            getValues('piecesIdentite') &&
            getValues('piecesIdentite').length > 0;
        // verification des pj chasseur
        if (motifs && motifs.isChasseur) {
            formulaireEstValide =
                formulaireEstValide &&
                watch('numeroPermisChasseur') &&
                getValues('permisDeChasse') &&
                getValues('permisDeChasse').length > 0;

            if (getValues('numeroGuichetUnique')) {
                formulaireEstValide =
                    formulaireEstValide &&
                    getValues('numeroGuichetUnique') &&
                    getValues('validationPermisChasser') &&
                    getValues('validationPermisChasser').length > 0;
            }
        }
        // vérification Licence

        if (motifs && motifs.isLicencie) {
            // au moins une licence
            formulaireEstValide =
                formulaireEstValide &&
                (watch('selectLicencieOrAncienLicencieTir') ||
                    watch('selectLicencieOrAncienLicencieBallTrap') ||
                    watch('selectLicencieOrAncienLicencieSki'));

            if (watch('selectLicencieOrAncienLicencieTir') === 'isLicencie') {
                formulaireEstValide = formulaireEstValide && watch('numeroLicenceTir');
            }
            if (watch('selectLicencieOrAncienLicencieSki') === 'isLicencie') {
                formulaireEstValide =
                    formulaireEstValide &&
                    watch('numeroLicenceSki') &&
                    watch('versoLicenceSki') &&
                    watch('versoLicenceSki').length > 0;
            }
            if (watch('selectLicencieOrAncienLicencieBallTrap') === 'isLicencie') {
                formulaireEstValide =
                    formulaireEstValide &&
                    watch('numeroLicenceBallTrap') &&
                    watch('versoLicenceBallTrap') &&
                    watch('versoLicenceBallTrap').length > 0;
            }
        }

        if (motifs && motifs.isMineur) {
            const typeLicenceMineur = watch('typeLicenceMineur');
            formulaireEstValide = formulaireEstValide && typeLicenceMineur;

            if (typeLicenceMineur === 'permisChasse') {
                formulaireEstValide =
                    formulaireEstValide &&
                    watch('numeroPermisChasseur') &&
                    getValues('permisDeChasse') &&
                    getValues('permisDeChasse').length > 0;
            } else if (typeLicenceMineur === 'tir') {
                if (watch('selectLicencieOrAncienLicencieTir') === 'isLicencie') {
                    formulaireEstValide =
                        formulaireEstValide &&
                        watch('numeroLicenceTir') &&
                        (!isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFTIR)
                            ? watch('versoLicenceTir') && watch('versoLicenceTir').length > 0
                            : true);
                }
            } else if (typeLicenceMineur === 'ballTrap') {
                if (watch('selectLicencieOrAncienLicencieBallTrap') === 'isLicencie') {
                    formulaireEstValide =
                        formulaireEstValide &&
                        watch('numeroLicenceBallTrap') &&
                        watch('versoLicenceBallTrap') &&
                        watch('versoLicenceBallTrap').length > 0;
                }
            } else if (typeLicenceMineur === 'ski') {
                if (watch('selectLicencieOrAncienLicencieSki') === 'isLicencie') {
                    formulaireEstValide =
                        formulaireEstValide &&
                        watch('numeroLicenceSki') &&
                        watch('versoLicenceSki') &&
                        watch('versoLicenceSki').length > 0;
                }
            }
        }

        if (IS_COLLECTIONNEUR_PHYSIQUE) {
            formulaireEstValide =
                formulaireEstValide &&
                watch('numeroCarteCollectionneur') &&
                watch('dateDelivranceCarteCollectionneur') &&
                getValues('carteCollectionneur') &&
                getValues('carteCollectionneur').length > 0;
        }

        return formulaireEstValide;
    };

    useEffect(() => {
        const envoyerRequetes = async () => {
            // Appels successifs et controlés pour éviter un chevauchement
            // du header provoquant une 403 liée au CSRF cookie
            if (dataIdentite?.piecesIdentite) {
                await postPiecesIdentite();
            }

            if (dataIdentite?.permisDeChasse) {
                await postPermisDeChasse();
            }

            if (dataIdentite?.autorisationDetentionArme) {
                await postAutorisisationDetentionArme();
            }

            if (dataIdentite?.validationPermisChasser) {
                await postValidationPermisChasser();
            }

            if (dataIdentite?.versoLicenceSki) {
                await postVersoLicenceSki();
            }

            if (dataIdentite?.versoLicenceBallTrap) {
                await postVersoLicenceBallTrap();
            }

            if (dataIdentite?.versoLicenceTir) {
                await postVersoLicenceTir();
            }

            if (dataIdentite?.pieceJustificativeMineur) {
                await postPieceJustificativeMineur();
            }

            if (dataIdentite?.carteCollectionneur) {
                await postCarteCollectionneur();
            }
        };

        if (!isLoading && data && !erreur) {
            envoyerRequetes();
        }
    }, [isLoading, data, erreur, dataIdentite]);

    const onSubmit = async (dataForm) => {
        dispatch({ type: CLEAR_ALERTES });
        window.scrollTo(0, 0); // Remonte la page en haut
        setDataIdentite(dataForm);
        const dataFormat = await formaterCreationIdentite(dataForm, uuidBrouillon);
        clearAlertes();
        // Envoi principal du formulaire
        await postApi(
            usagerClientReducer,
            API_COMPTE_CREER_IDENTITE_URL,
            {
                ...dataFormat,
                typeStatut: statutCompteMetierAsso ? 'metier.association' : 'particulier',
                subTypeStatut: statutCompteMetierAsso?.typeMetierAssociation,
                mineur: motifs?.isMineur ?? false,
            },
            CONTEXT_CREER_COMPTE_ETAPE_IDENTITE,
        );
    };

    const renderMessage = (msg) => {
        return msg.split('\n').map((line) => <p key={line}>{line}</p>);
    };

    useEffect(() => {
        if (isLoading) {
            // Vérification des licences et génération du message approprié
            if (
                (isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFTIR) &&
                    getValues('numeroLicenceTir') &&
                    getValues('selectLicencieOrAncienLicencieTir') === 'isLicencie') ||
                (isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFBT) &&
                    getValues('numeroLicenceBallTrap') &&
                    getValues('selectLicencieOrAncienLicencieBallTrap') === 'isLicencie')
            ) {
                triggerToaster();
            }
        } else {
            closeToaster();
        }
    }, [isLoading, featureFlipping]);

    return (
        <SegmentLoader
            isLoading={
                isLoading ||
                isLoadingRenseignerPiecesIdentite ||
                isLoadingPermisDeChasse ||
                isLoadingValidationPermisChasser ||
                isLoadingVersoLicenceSki ||
                isLoadingVersoLicenceBallTrap
            }
        >
            {erreur && message && (
                <Row>
                    <Col col={12}>
                        <div className="fr-error">{renderMessage(message)}</div>
                    </Col>
                </Row>
            )}
            <FormProvider {...hookForm}>
                {!IS_METIER_ET_ASSOCIATION_PERSONNE_MORAL && (
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col col={12}>
                                <InfoChampsObligatoire />
                            </Col>
                        </Row>

                        {IS_CHASSEUR_STATUT && <InformationChasseur />}

                        {motifs && motifs.isLicencie && (
                            <InformationLicencie featureFlipping={featureFlipping} />
                        )}

                        {motifs && motifs.isMineur && (
                            <InformationLicencieMineur featureFlipping={featureFlipping} />
                        )}

                        {motifs.isDetenteurProfessionnel &&
                            (IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_RISQUE_PRO ||
                                IS_METIER_ET_ASSOCIATION_PERSONNE_PHYSIQUE_RISQUE_EXCEPTIONNELS) && (
                                <InformationPersonneRisque />
                            )}
                        <Row className="margin-top-lg">
                            <Col col={12}>
                                <h3>Identité</h3>
                            </Col>
                        </Row>
                        <Row gutters verticalAlign="bottom">
                            <Col col={12} lg={6}>
                                <SelectControl
                                    id="sexe"
                                    name="Sexe *"
                                    label="Sexe *"
                                    options={formaterOptions(choixSexe)}
                                    required
                                    state={formState.errors?.sexe ? 'error' : null}
                                    message={formState.errors?.sexe?.message}
                                    {...register('sexe', {
                                        required: getMessageErreurChampManquant('sexe'),
                                    })}
                                    placeholder="-- Choisir une option --"
                                />
                            </Col>
                            <Col col={12} lg={6}>
                                <InputControl
                                    autocomplete="family-name"
                                    id="nom"
                                    label="Nom *"
                                    required
                                    uppercase
                                    {...register('nom', {
                                        required: getMessageErreurChampManquant('nom'),
                                        pattern: getPatternHookFormValidation(
                                            REGEXP_NOM_PRENOM,
                                            'nom',
                                        ),
                                    })}
                                    state={formState.errors?.nom ? 'error' : null}
                                    message={formState.errors?.nom?.message}
                                />
                            </Col>
                        </Row>
                        <Row gutters verticalAlign="bottom">
                            <Col col={12} lg={6}>
                                <InputControl
                                    autocomplete="family-name"
                                    id="nomUsage"
                                    label="Nom d'usage"
                                    hintText="Nom de famille utilisé dans la vie courante, à renseigner s'il ne s'agit pas du nom de naissance."
                                    uppercase
                                    {...register('nomUsage', {
                                        pattern: getPatternHookFormValidation(
                                            REGEXP_NOM_PRENOM,
                                            "nom d'usage",
                                        ),
                                    })}
                                    state={formState.errors?.nomUsage ? 'error' : null}
                                    message={formState.errors?.nomUsage?.message}
                                />
                            </Col>
                            <Col col={12} lg={6}>
                                <InputControl
                                    autocomplete="given-name"
                                    id="prenomUn"
                                    label="Premier prénom *"
                                    required
                                    uppercase
                                    {...register('prenomUn', {
                                        required: getMessageErreurChampManquant('premier prénom'),
                                        pattern: getPatternHookFormValidation(
                                            REGEXP_NOM_PRENOM,
                                            'premier prénom',
                                        ),
                                    })}
                                    state={formState.errors?.prenomUn ? 'error' : null}
                                    message={formState.errors?.prenomUn?.message}
                                />
                            </Col>
                        </Row>
                        <Row gutters verticalAlign="bottom">
                            <Col col={12} lg={6}>
                                <InputControl
                                    autocomplete="additional-name"
                                    id="prenomDeux"
                                    label="Deuxième prénom"
                                    disabled={!getValues('prenomUn')}
                                    {...register('prenomDeux', {
                                        pattern: getPatternHookFormValidation(
                                            REGEXP_NOM_PRENOM,
                                            'deuxième prénom',
                                        ),
                                    })}
                                    uppercase
                                    state={formState.errors?.prenomDeux ? 'error' : null}
                                    message={formState.errors?.prenomDeux?.message}
                                />
                            </Col>
                            <Col col={12} lg={6}>
                                <InputControl
                                    autocomplete="additional-name"
                                    id="prenomTrois"
                                    label="Troisième prénom"
                                    disabled={!getValues('prenomUn') || !getValues('prenomDeux')}
                                    {...register('prenomTrois', {
                                        pattern: getPatternHookFormValidation(
                                            REGEXP_NOM_PRENOM,
                                            'troisième prénom',
                                        ),
                                    })}
                                    uppercase
                                    state={formState.errors?.prenomTrois ? 'error' : null}
                                    message={formState.errors?.prenomTrois?.message}
                                />
                            </Col>
                        </Row>
                        <Row gutters verticalAlign="bottom">
                            <Col col={12} lg={6}>
                                <InputControl
                                    autocomplete="additional-name"
                                    id="prenomQuatre"
                                    label="Quatrième prénom"
                                    disabled={
                                        !getValues('prenomUn') ||
                                        !getValues('prenomDeux') ||
                                        !getValues('prenomTrois')
                                    }
                                    {...register('prenomQuatre', {
                                        pattern: getPatternHookFormValidation(
                                            REGEXP_NOM_PRENOM,
                                            'quatrième prénom',
                                        ),
                                    })}
                                    uppercase
                                    state={formState.errors?.prenomQuatre ? 'error' : null}
                                    message={formState.errors?.prenomQuatre?.message}
                                />
                            </Col>
                            <Col col={12} lg={6}>
                                <InputControl
                                    autocomplete="given-name"
                                    id="prenomUsuel"
                                    label="Prénom usuel"
                                    hintText="Prénom utilisé dans la vie courante, il doit être identique à l'un des prénoms renseignés dans le formulaire."
                                    {...register('prenomUsuel', {
                                        pattern: getPatternHookFormValidation(
                                            REGEXP_NOM_PRENOM,
                                            'prénom usuel',
                                        ),
                                        validate: (value) => validatePrenomUsuel(value),
                                    })}
                                    uppercase
                                    state={formState.errors?.prenomUsuel ? 'error' : null}
                                    message={formState.errors?.prenomUsuel?.message}
                                />
                            </Col>
                        </Row>
                        <Row gutters verticalAlign="bottom">
                            <Col col={12} lg={6}>
                                <InputControl
                                    autocomplete="bday"
                                    id="dateNaissance"
                                    label="Date de naissance *"
                                    required
                                    hintText="Exemple : 27/05/2001"
                                    {...register('dateNaissance', {
                                        required:
                                            getMessageErreurChampManquant('Date de naissance'),
                                        pattern: getPatternHookFormValidation(
                                            REGEXP_DATE_AVEC_MOIS_JOUR_INCONNU,
                                            '',
                                            MESSAGE_DATE_INVALIDE,
                                        ),
                                        validate: {
                                            validateDate: (value) => validateDate(value),
                                            validateAge: (value) => validateAge(value),
                                        },
                                        onChange: () => {
                                            setValueRecherche('');
                                            setValue('lieuNaissance', '');
                                        },
                                    })}
                                    state={formState.errors?.dateNaissance ? 'error' : null}
                                    message={formState.errors?.dateNaissance?.message}
                                    maskFonction={getDateFormatWithSlash}
                                />
                            </Col>
                            <Col col={12} lg={6}>
                                <SelectPays
                                    id="paysNaissance"
                                    name="paysNaissance"
                                    label="Pays de naissance *"
                                    required
                                    register={register('paysNaissance', {
                                        onChange: () => {
                                            setValueRecherche('');
                                            setValue('lieuNaissance', '');
                                        },
                                        required:
                                            getMessageErreurChampManquant('pays de Naissance'),
                                    })}
                                    placeholder="-- Choisir une option --"
                                />
                            </Col>
                        </Row>
                        <Row gutters verticalAlign="bottom">
                            <Col col={12} lg={6}>
                                <SelectCommune
                                    name="communneNaissance"
                                    label="Lieu de naissance"
                                    valueRecherche={valueRecherche}
                                    setValueRecherche={setValueRecherche}
                                />
                            </Col>
                        </Row>
                        <Row gutters verticalAlign="bottom">
                            <Col col={12} lg={6}>
                                <SelectPays
                                    id="nationalite"
                                    name="nationalite"
                                    label="Nationalité *"
                                    required
                                    register={register('nationalite', {
                                        required: getMessageErreurChampManquant('nationalité'),
                                    })}
                                    placeholder="-- Choisir une option --"
                                />
                            </Col>
                            {motifs && !motifs.isNonLicencie && !motifs.isMineur && (
                                <Col col={12} lg={6}>
                                    <InputControl
                                        id="numeroSia"
                                        label="Si vous possédez déjà un numéro SIA, veuillez le renseigner ci-dessous"
                                        uppercase
                                        {...register('numeroSia', {
                                            setValueAs: (v) => (v ? v.toUpperCase() : null),
                                        })}
                                    />
                                </Col>
                            )}
                        </Row>
                        <Row gutters horizontalAlign="center" verticalAlign="bottom">
                            <Col col={12} lg={6}>
                                <div className="sia-input-alignementSansTexteAide">
                                    <SelectControl
                                        id="typePieceIdentite"
                                        name="typePieceIdentite"
                                        label="Sélectionnez votre type de pièce d'identité *"
                                        options={formaterOptions(typePieceIdentite)}
                                        required
                                        {...register('typePieceIdentite', {
                                            required: getMessageErreurChampManquant(
                                                "type de pièce d'identité",
                                            ),
                                        })}
                                        placeholder="-- Choisir une option --"
                                    />
                                </div>
                            </Col>
                            <Col col={12} lg={6}>
                                <InputControl
                                    required
                                    id="numeroPieceIdentite"
                                    label="Numéro de la pièce d'identité *"
                                    hintText="Le nombre de caractères de la pièce d'identité est limité à 50."
                                    {...register('numeroPieceIdentite', {
                                        required: getMessageErreurChampManquant(
                                            "numéro de la pièce d'identité",
                                        ),
                                    })}
                                    state={formState.errors?.numeroPieceIdentite ? 'error' : null}
                                    message={formState.errors?.numeroPieceIdentite?.message}
                                    maxLength="50"
                                />
                            </Col>
                        </Row>
                        <Row gutters horizontalAlign="center" verticalAlign="bottom">
                            <Col col={12} lg={6}>
                                <InputControl
                                    id="dateDelivrance"
                                    label="Date de délivrance du document *"
                                    required
                                    hintText="Exemple : 01/02/1999"
                                    {...register('dateDelivrance', {
                                        required: getMessageErreurChampManquant(
                                            'Date de délivrance du document',
                                        ),
                                        pattern: getPatternHookFormValidation(
                                            REGEXP_DATE_AVEC_MOIS_JOUR_INCONNU,
                                            '',
                                            MESSAGE_DATE_INVALIDE,
                                        ),
                                        validate: {
                                            validateDate: (value) => validateDate(value),
                                        },
                                    })}
                                    state={formState.errors?.dateDelivrance ? 'error' : null}
                                    message={formState.errors?.dateDelivrance?.message}
                                    maskFonction={getDateFormatWithSlash}
                                />
                            </Col>
                            <Col col={12} lg={6}>
                                <InputFiles
                                    name="piecesIdentite"
                                    label="Ajouter ma pièce d'identité"
                                    error={
                                        formState.errors ? formState.errors.piecesIdentite : null
                                    }
                                    required
                                    multiple
                                />
                            </Col>
                        </Row>
                        {IS_COLLECTIONNEUR_PHYSIQUE && (
                            <ChampsCarteCollectionneur validateDate={validateDate} />
                        )}
                        {motifs && motifs.isMineur && watch('nationalite') && (
                            <Row gutters>
                                <Col col={12}>
                                    <InputFiles
                                        name="pieceJustificativeMineur"
                                        label={
                                            watch('nationalite') === NUMERO_FRANCE
                                                ? "Extrait d'acte de naissance de moins de 3 mois"
                                                : 'Certificat de non-inscription au répertoire civil'
                                        }
                                        error={
                                            formState.errors
                                                ? formState.errors.pieceJustificativeMineur
                                                : null
                                        }
                                        required
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row className="margin-top-lg">
                            <Col>
                                <ButtonGroup inline align="right">
                                    <Button
                                        name="etapePrecedente"
                                        variant="secondary"
                                        type="button"
                                        isLoading={
                                            isLoading ||
                                            isLoadingRenseignerPiecesIdentite ||
                                            isLoadingPermisDeChasse ||
                                            isLoadingValidationPermisChasser ||
                                            isLoadingVersoLicenceSki ||
                                            isLoadingVersoLicenceBallTrap ||
                                            isLoadingPieceJustificativeMineur ||
                                            isLoadingCarteCollectionneur
                                        }
                                        onClick={retourEtape}
                                    >
                                        Retour
                                    </Button>
                                    <Button
                                        name="etapeSuivante"
                                        variant="primary"
                                        type="submit"
                                        isLoading={
                                            isLoading ||
                                            isLoadingRenseignerPiecesIdentite ||
                                            isLoadingPermisDeChasse ||
                                            isLoadingValidationPermisChasser ||
                                            isLoadingVersoLicenceSki ||
                                            isLoadingVersoLicenceBallTrap ||
                                            isLoadingPieceJustificativeMineur ||
                                            isLoadingCarteCollectionneur
                                        }
                                        disabled={!hasFormValid()}
                                    >
                                        Accéder à l'étape suivante
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </form>
                )}
            </FormProvider>
        </SegmentLoader>
    );
};

CreerCompteIdentite.propTypes = {
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    erreur: PropTypes.bool,
    data: PropTypes.shape({
        uuidBrouillon: PropTypes.string.isRequired,
    }),
    message: PropTypes.string,
    isLoadingRenseignerPiecesIdentite: PropTypes.bool,
    erreurRenseignerPiecesIdentite: PropTypes.bool,
    dataRenseignerPiecesIdentite: PropTypes.string.isRequired,
    isLoadingPermisDeChasse: PropTypes.bool,
    erreurPermisDeChasse: PropTypes.bool,
    dataRenseignerPermisDeChasse: PropTypes.string.isRequired,
    isLoadingValidationPermisChasser: PropTypes.bool,
    erreurValidationPermisChasser: PropTypes.bool,
    dataRenseignerAutorisationPortArme: PropTypes.string.isRequired,
    isLoadingAutorisationPortArme: PropTypes.bool,
    erreurAutorisationPortArme: PropTypes.bool,
    dataRenseignerValidationPermisChasser: PropTypes.string.isRequired,
    erreurVersoLicenceSki: PropTypes.bool,
    isLoadingVersoLicenceSki: PropTypes.bool,
    dataRenseignerVersoLicenceSki: PropTypes.string.isRequired,
    erreurVersoLicenceBallTrap: PropTypes.bool,
    isLoadingVersoLicenceBallTrap: PropTypes.bool,
    dataRenseignerVersoLicenceBallTrap: PropTypes.string.isRequired,
    erreurVersoLicenceTir: PropTypes.bool,
    isLoadingVersoLicenceTir: PropTypes.bool,
    dataRenseignerVersoLicenceTir: PropTypes.string.isRequired,
    erreurPieceJustificativeMineur: PropTypes.bool,
    isLoadingPieceJustificativeMineur: PropTypes.bool,
    dataRenseignerPieceJustificativeMineur: PropTypes.string.isRequired,
    isLoadingCarteCollectionneur: PropTypes.bool,
    erreurCarteCollectionneur: PropTypes.bool,
    dataRenseignerCarteCollectionneur: PropTypes.string.isRequired,
    setEtapeIdentite: PropTypes.func.isRequired,
    setAncienLicencie: PropTypes.func.isRequired,
    dataIdentiteRenseignee: PropTypes.shape({
        dateNaissance: PropTypes.string,
        lieuNaissance: PropTypes.string,
        idNationalite: PropTypes.number,
        idPaysNaissance: PropTypes.number,
        nom: PropTypes.string,
        nomUsage: PropTypes.string,
        numeroPermisChasseur: PropTypes.string,
        numeroLicenceBallTrap: PropTypes.string,
        numeroLicenceSki: PropTypes.string,
        numeroLicenceTir: PropTypes.string,
        versoLicenceTir: PropTypes.instanceOf(FileUploadeAbstract),
        versoLicenceSki: PropTypes.instanceOf(FileUploadeAbstract),
        versoLicenceBallTrap: PropTypes.instanceOf(FileUploadeAbstract),
        selectLicencieOrAncienLicencieBallTrap: PropTypes.string,
        selectLicencieOrAncienLicencieSki: PropTypes.string,
        selectLicencieOrAncienLicencieTir: PropTypes.string,
        typeLicenceMineur: PropTypes.string,
        prenomUn: PropTypes.string,
        prenomDeux: PropTypes.string,
        prenomTrois: PropTypes.string,
        prenomQuatre: PropTypes.string,
        prenomUsuel: PropTypes.string,
        sexe: PropTypes.string,
        numeroPieceIdentite: PropTypes.string,
        typePieceIdentite: PropTypes.string,
        piecesIdentite: PropTypes.arrayOf(PropTypes.instanceOf(FileUploadeAbstract)),
        typePieceJustificativeMetierEtAssociation: PropTypes.string,
        justificatifMetierEtAssociation: PropTypes.arrayOf(
            PropTypes.instanceOf(FileUploadeAbstract),
        ),
        numeroGuichetUnique: PropTypes.instanceOf(FileUploadeAbstract),
        permisDeChasse: PropTypes.instanceOf(FileUploadeAbstract),
        autorisationDetentionArme: PropTypes.instanceOf(FileUploadeAbstract),
        validationPermisChasser: PropTypes.instanceOf(FileUploadeAbstract),
        numeroSia: PropTypes.string,
        dateDelivrance: PropTypes.string,
        numeroCarteCollectionneur: PropTypes.string,
        dateDelivranceCarteCollectionneur: PropTypes.string,
        carteCollectionneur: PropTypes.instanceOf(FileUploadeAbstract),
    }),
    uuidBrouillon: PropTypes.string,
    motifs: PropTypes.object.isRequired,
    retourEtape: PropTypes.func.isRequired,
    featureFlipping: PropTypes.object.isRequired,
    clearAlertes: PropTypes.func.isRequired,
    statutCompteMetierAsso: PropTypes.shape({
        statut: PropTypes.string,
        typeMetierAssociation: PropTypes.string,
    }),
};

export default connect(
    (state) => {
        const { isLoading, erreur, message, data } = state.compte.creer.renseignerIdentite;
        const {
            data: dataRenseignerPiecesIdentite,
            isLoading: isLoadingRenseignerPiecesIdentite,
            erreur: erreurRenseignerPiecesIdentite,
        } = state.compte.creer.renseignerPiecesIdentite;
        const {
            data: dataRenseignerPermisDeChasse,
            isLoading: isLoadingPermisDeChasse,
            erreur: erreurPermisDeChasse,
        } = state.compte.creer.renseignerPermisDeChasse;
        const {
            data: dataRenseignerAutorisationPortArme,
            isLoading: isLoadingAutorisationPortArme,
            erreur: erreurAutorisationPortArme,
        } = state.compte.creer.renseignerAutorisationPortArme;
        const {
            data: dataRenseignerValidationPermisChasser,
            isLoading: isLoadingValidationPermisChasser,
            erreur: erreurValidationPermisChasser,
        } = state.compte.creer.renseignerValidationPermisChasser;
        const {
            data: dataRenseignerVersoLicenceSki,
            isLoading: isLoadingVersoLicenceSki,
            erreur: erreurVersoLicenceSki,
        } = state.compte.creer.renseignerVersoLicenceSki;
        const {
            data: dataRenseignerVersoLicenceBallTrap,
            isLoading: isLoadingVersoLicenceBallTrap,
            erreur: erreurVersoLicenceBallTrap,
        } = state.compte.creer.renseignerVersoLicenceBallTrap;
        const {
            data: dataRenseignerVersoLicenceTir,
            isLoading: isLoadingVersoLicenceTir,
            erreur: erreurVersoLicenceTir,
        } = state.compte.creer.renseignerVersoLicenceTir;
        const {
            data: dataRenseignerPieceJustificativeMineur,
            isLoading: isLoadingPieceJustificativeMineur,
            erreur: erreurPieceJustificativeMineur,
        } = state.compte.creer.renseignerPieceJustificativeMineur;
        const {
            data: dataRenseignerCarteCollectionneur,
            isLoading: isLoadingCarteCollectionneur,
            erreur: erreurCarteCollectionneur,
        } = state.compte.creer.renseignerCarteCollectionneur;

        const { statutCompteMetierAsso } = state.compte.creer;

        return {
            isLoading,
            erreur,
            data,
            message,
            dataRenseignerPiecesIdentite,
            isLoadingRenseignerPiecesIdentite,
            erreurRenseignerPiecesIdentite,
            dataRenseignerPermisDeChasse,
            isLoadingPermisDeChasse,
            erreurPermisDeChasse,
            dataRenseignerAutorisationPortArme,
            isLoadingAutorisationPortArme,
            erreurAutorisationPortArme,
            dataRenseignerValidationPermisChasser,
            isLoadingValidationPermisChasser,
            erreurValidationPermisChasser,
            dataRenseignerVersoLicenceSki,
            isLoadingVersoLicenceSki,
            erreurVersoLicenceSki,
            dataRenseignerVersoLicenceBallTrap,
            isLoadingVersoLicenceBallTrap,
            erreurVersoLicenceBallTrap,
            dataRenseignerVersoLicenceTir,
            isLoadingVersoLicenceTir,
            erreurVersoLicenceTir,
            dataRenseignerPieceJustificativeMineur,
            isLoadingPieceJustificativeMineur,
            erreurPieceJustificativeMineur,
            dataRenseignerCarteCollectionneur,
            isLoadingCarteCollectionneur,
            erreurCarteCollectionneur,
            statutCompteMetierAsso,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
        clearAlertes: hideAllNotification,
    },
)(CreerCompteIdentite);
